module.exports = __webpack_public_path__ + "img/download.2360f6f6.svg";